import axios from "axios";
import { endpoint, token_refresh_URL } from "../constants";
import Cookies from "universal-cookie";
import { logout } from "../app/Actions/auth";

import { openNotificationWithIcon } from "../containers/Function";

const cookies = new Cookies();

const authAxiosTest = () => {
  // const cookies = new Cookies({ domain: '.dominatech.xyz' });
  const token = cookies.get("token");
  const axiosTest = axios.create({
    baseURL: endpoint,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  axiosTest.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return new Promise((resolve, reject) => {
        const oroginReq = error.config;

        try {
          if (
            error.response.status === 400 ||
            error.response.status === 404 ||
            error.response.status === 500 ||
            error.response.status === 403
          ) {

            reject(error.response); // trả kết quả đúng ở catch
            // reject(new Error(error.response));
          }
          if (error.response.status === 403) {
            openNotificationWithIcon(
              "error",
              "Lỗi",
              "Bạn không có quyền xem chức năng này"
            );
            reject(error.response);
            // message.error("Không tìm thấy dữ liệu");
          } else if (error.response.status === 401 && error.config) {
            oroginReq._retry = true;
            logout();
            window.location = "/login";
            // let refresh = cookies.get('refresh');
            // if (refresh) {
            //     let res = fetch(token_refresh_URL, {
            //         method: 'POST',
            //         mode: 'cors',
            //         headers: {
            //             'Content-Type': 'application/json'
            //         },
            //         body: JSON.stringify({
            //             refresh: cookies.get('refresh')
            //         })
            //     }).then(res => res.json()).then(res => {
            //         // console.log(res);
            //         oroginReq.headers.Authorization = `Bearer ${res.access}`;
            //         // cookies.set("token",res.access);
            //         return axios(oroginReq);
            //     }).catch(err => { // 090823 Hết hạn cookies refresh
            //         window.location = "/login"
            //     });
            //     resolve(res);
            // } else {
            //     window.location = "/login"
            // }
          }
        } catch (e) {
          localStorage.setItem("error_s", "1");
          // logout();
          window.location = "/login";
          // message.success('Lỗi kết nối, kiểm tra kết nối tới server1 !!!', 10);
        }
        return error; //Promise.reject(error);
      });
    }
  );

  return axiosTest;
};

export const authAxios = () => authAxiosTest();
